@use '../../../styles/variables' as *;

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fade-in 0.3s ease-out;
}

.content {
  text-align: center;
  animation: pop 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.icon {
  font-size: 64px;
  margin-bottom: $space-lg;
}

.title {
  font-size: $font-3xl;
  font-weight: bold;
  color: $color-gold;
  text-shadow:
    0 0 20px rgba($color-gold, 0.5),
    0 2px 4px rgba(0, 0, 0, 0.8);
  letter-spacing: 2px;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes pop {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
